import React, { Component } from "react";
import FileUploader from "./FileUploader";

class FileUploaderContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedFiles: []
    };

    this.promiseBarRef = React.createRef();
    this.inputRef = React.createRef();
  }

  onSelect = event => {
    this.setState({ selectedFiles: event.target.files });
  };

  onUpload = event => {
    event.preventDefault();

    this.props.onUpload(this.state.selectedFiles);

    //this line must be called after promise start!
    this.promiseBarRef.current.start();
  };

  onError = () => {
    this.promiseBarRef.current.error();
  };

  reset = () => {
    this.promiseBarRef.current.reset();
    this.inputRef.current.value = "";

    this.setState({ selectedFiles: [] });
  };

  render() {
    return (
      <FileUploader
        multiple={this.props.multiple}
        selected={this.state.selectedFiles}
        onSelect={this.onSelect}
        onUpload={this.onUpload}
        promiseBarRef={this.promiseBarRef}
        inputRef={this.inputRef}
        disabled={this.props.disabled}
      />
    );
  }
}

export default FileUploaderContainer;
